import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { clearPending } from 'api/actions'

/**
 *
 * @param {PendingObject} pending - pending object from redux store
 * @param {callback} [onSuccess] - on success callback
 * @param {string} [pendingConstant] - clear given pending by name
 * @returns
 */
export default function useRequestPending(pending, onSuccess = () => {}, pendingConstant) {
    const [sent, setSent] = useState(false)
    const dispatch = useDispatch()

    const error = pending instanceof Error && pending.message
    const isLoading = pending === true

    useEffect(() => {
        if (pending && !error && !sent) {
            setSent(true)
        } else if (!pending && !error && sent) {
            onSuccess()
        }
    }, [pending, error])

    useEffect(
        () => () => {
            pendingConstant && dispatch(clearPending([pendingConstant]))
        },
        []
    )

    return { error, isLoading }
}
